<button kendoButton *ngIf="visible" tabindex="-1" [popover]="myPopover" class="ml-4"
    [trimRichtextAriaLabel]="InfotextBeschreibung" kendoPopoverAnchor #anchor="kendoPopoverAnchor" showOn="hover">
    <i class="k-icon k-i-information d-flex"></i>
</button>
<kendo-popover #myPopover [width]="300" position="bottom">
    <ng-template kendoPopoverTitleTemplate>
        <div class="popover-title" translate *ngIf="showBaseTitle">
            infotext.infotext</div>
        <div class="popover-title" translate *ngIf="!showBaseTitle" [trimRichtextAriaLabel]="InfotextTitle">
            {{InfotextTitle}}</div>
    </ng-template>

    <ng-template kendoPopoverBodyTemplate>
        <div [innerHTMLBypassXSS]="InfotextBeschreibung" [trimRichtextAriaLabel]="InfotextBeschreibung"></div>
    </ng-template>
</kendo-popover>